import axios from 'axios';
import { NOTIFICATIONS_ENDPOINT } from '../constants/endpoint';

export const GetNotifications = async prospectId => axios.get(`${NOTIFICATIONS_ENDPOINT}/${prospectId}`);
